import type { Entry } from 'contentful';

import { TypeMaintenanceBannerSkeleton } from '../models/cms';

const parseDate = (date: string) =>
  `${new Date(date).toLocaleTimeString('en-GB', { timeStyle: 'short', timeZone: 'UTC' })}, ${new Date(date).toLocaleDateString('en-GB')}`;

const formatDateToUnixTimeStamp = (dateString: string) => new Date(dateString).getTime();

export const transformMaintenanceBanners = (banners: Entry<TypeMaintenanceBannerSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>[]) => {
  const transformedBanners = banners.map(({ fields }) => {
    const scheduleStartTime = formatDateToUnixTimeStamp(fields.scheduleStartTime);
    const scheduleEndTime = formatDateToUnixTimeStamp(fields.scheduleEndTime);
    const text = fields.text.replace('{{startTime}}', parseDate(fields.startTime)).replace('{{endTime}}', parseDate(fields.endTime));
    const moreText =
      fields.moreText && fields.moreText.replace('{{startTime}}', parseDate(fields.startTime)).replace('{{endTime}}', parseDate(fields.endTime));

    const { seeMoreLabel, seeLessLabel } = fields;

    return { scheduleEndTime, scheduleStartTime, text, moreText, seeMoreLabel, seeLessLabel };
  });

  const today = new Date().getTime();

  return transformedBanners
    .filter((banner) => today >= banner.scheduleStartTime && today <= banner.scheduleEndTime)
    .map(({ text, moreText, seeMoreLabel, seeLessLabel }) => ({ text, moreText, seeMoreLabel, seeLessLabel }));
};
